import { __rest } from "tslib";
import * as React from 'react';
import { composeRefs } from '../helpers';
export const Slot = React.forwardRef((props, forwardedRef) => {
    const { children } = props, slotProps = __rest(props, ["children"]);
    const childrenArray = React.Children.toArray(children);
    const slottable = childrenArray.find(isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child) => {
            if (child === slottable) {
                if (React.Children.count(newElement) > 1)
                    return React.Children.only(null);
                return React.isValidElement(newElement)
                    ? newElement.props.children
                    : null;
            }
            else {
                return child;
            }
        });
        return (React.createElement(SlotClone, Object.assign({}, slotProps, { ref: forwardedRef }), React.isValidElement(newElement)
            ? React.cloneElement(newElement, undefined, newChildren)
            : null));
    }
    return (React.createElement(SlotClone, Object.assign({}, slotProps, { ref: forwardedRef }), children));
});
Slot.displayName = 'Slot';
const SlotClone = React.forwardRef((props, forwardedRef) => {
    const { children } = props, slotProps = __rest(props, ["children"]);
    if (React.isValidElement(children)) {
        const childrenRef = getElementRef(children);
        return React.cloneElement(children, Object.assign(Object.assign({}, mergeProps(slotProps, children.props)), { ref: forwardedRef
                ? composeRefs(forwardedRef, childrenRef)
                : childrenRef }));
    }
    return React.Children.count(children) > 1 ? React.Children.only(null) : null;
});
SlotClone.displayName = 'SlotClone';
const Slottable = ({ children }) => {
    return React.createElement(React.Fragment, null, children);
};
function isSlottable(child) {
    return React.isValidElement(child) && child.type === Slottable;
}
function mergeProps(slotProps, childProps) {
    const overrideProps = Object.assign({}, childProps);
    for (const propName in childProps) {
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) {
                overrideProps[propName] = (...args) => {
                    childPropValue(...args);
                    slotPropValue(...args);
                };
            }
            else if (slotPropValue) {
                overrideProps[propName] = slotPropValue;
            }
        }
        else if (propName === 'style') {
            overrideProps[propName] = Object.assign(Object.assign({}, slotPropValue), childPropValue);
        }
        else if (propName === 'className') {
            overrideProps[propName] = [slotPropValue, childPropValue]
                .filter(Boolean)
                .join(' ');
        }
    }
    return Object.assign(Object.assign({}, slotProps), overrideProps);
}
function getElementRef(element) {
    var _a, _b;
    let getter = (_a = Object.getOwnPropertyDescriptor(element.props, 'ref')) === null || _a === void 0 ? void 0 : _a.get;
    let mayWarn = getter && 'isReactWarning' in getter && getter.isReactWarning;
    if (mayWarn) {
        return element.ref;
    }
    getter = (_b = Object.getOwnPropertyDescriptor(element, 'ref')) === null || _b === void 0 ? void 0 : _b.get;
    mayWarn = getter && 'isReactWarning' in getter && getter.isReactWarning;
    if (mayWarn) {
        return element.props.ref;
    }
    return element.props.ref || element.ref;
}
//# sourceMappingURL=Slot.js.map